module.exports = __webpack_public_path__ + "img/hand_sign_emoji_icon.39ad9bb8.png";